const CASEFORM_FLUSH_EVENT = 'resolvex-caseform-flush-saves'
const FLUSH_TIMEOUT_MS = 3000

interface CaseformFlushEventDetail {
  done: () => void
}

export async function flushCaseformPendingSaves(): Promise<void> {
  return new Promise((resolve) => {
    const timeout = setTimeout(resolve, FLUSH_TIMEOUT_MS)

    window.dispatchEvent(
      new CustomEvent<CaseformFlushEventDetail>(CASEFORM_FLUSH_EVENT, {
        detail: {
          done: () => {
            clearTimeout(timeout)
            resolve()
          },
        },
      })
    )
  })
}
